import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import DeleteButton from './DeleteButton';

export default class MyTable extends Component {
    constructor(props) {
        super(props);
    }

    render(){
        const { headings, data, actions, url, imageUpload, isDelete, deleteRedirect, hideViewEdit, showNum} = this.props;

        let headingHTML = headings.map((h, i) => {
            return (<th key={`th-${i}`}>{h}</th>);
        });

        if(showNum){
            headingHTML.unshift(<th key={`th-num`}>#</th>);
        }

        let imageUploadHTML = "";
        let actionsHTML = "";
        let deleteHTML = "";

        if(actions){
            headingHTML.push(<th key={`th-actions`}></th>);
        }

        let dataHTML = data.map((row, i) => {

            if(actions && !hideViewEdit){
                actionsHTML = (
                    <Link to={`${url}/${row.id}/edit`}>
                        <button className="btn btn-primary btn-sm">View/Edit</button>
                    </Link>
                );
            }

            if(isDelete){
                deleteHTML = (
                    <DeleteButton route={url} id={row.id} label='Delete' redirect={deleteRedirect} small={true} />
                );
            }

            if(imageUpload){
                imageUploadHTML = (
                    <Link to={`${url}/${row.id}/upload`}>
                        <button className="btn btn-info btn-sm ml10">Edit images</button>
                    </Link>
                );
            }

            let td = headings.map((h, i) => {
                return (<td key={`td-${i}`}>{row[h]}</td>);
            })

            if(showNum){
                td.unshift(<td key={`td-num-${i}`}>{i+1}</td>);
            }

            if(actions){
                td.push(
                    <td key={`td-actions`}>
                        {actionsHTML}
                        {imageUploadHTML}
                        {deleteHTML}
                    </td>
                );
            }

            return (
                <tr key={`tr-${i}`}>
                    {td}
                </tr>
            );
        });

        return (
            <table className="table table-bordered table-hover table-striped">
                <thead>
                <tr>{headingHTML}</tr>
                </thead>
                <tbody>
                {dataHTML}
                </tbody>
            </table>
        );
    }
}
